import React, { useState } from "react";
import Modal from "react-modal";
import { motion } from "framer-motion";

// Obligatoire pour accessibilité (React)
Modal.setAppElement("#root");

// Fonction pour tronquer le texte
const truncateText = (text, maxLength) => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

const ServicesDetails = ({ id, title, subtitle, icon, description, features, image }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      {/* Card principale */}
      <motion.section
        className="p-4"
        id={id}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden hover:shadow-xl transform transition-transform hover:scale-105">
          <div className="p-6">
            <div className="flex justify-center mb-2">
              <div className="bg-blue-100 dark:bg-blue-800 p-2 rounded-full">
                {icon}
              </div>
            </div>
            <h4 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-200 mb-2">
              {title}
            </h4>
            <h5 className="text-lg text-center text-gray-600 dark:text-gray-400 mb-2">
              {subtitle}
            </h5>
            <p className="text-sm text-center text-gray-700 dark:text-gray-300 mb-2">
              {truncateText(description, 100)}
            </p>
            {features && features.length > 0 && (
              <ul className="text-sm list-disc list-inside text-gray-600 dark:text-gray-400">
                <li className="mb-2">{features[0]}</li>
              </ul>
            )}
            <div className="text-center mt-6">
              <button
                onClick={openModal}
                className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg"
              >
                Voir plus...
              </button>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Détails du service"
        className="modal-content bg-white dark:bg-gray-900 p-6 rounded-lg shadow-2xl max-w-2xl mx-auto mt-20"
        overlayClassName="modal-overlay fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center"
      >
        <div className="flex flex-col md:flex-row gap-6 items-center">
          {/* Image */}
          <div className="w-full md:w-1/2">
            <img
              src='images/lizayTech.jpg'
              alt="Illustration du service"
              className="rounded-lg object-cover w-full h-64 shadow-md"
            />
          </div>

          {/* Contenu */}
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl font-semibold text-gray-800 dark:text-white mb-4">
              {title}
            </h2>
            <p className="mb-4 text-gray-600 dark:text-gray-300">{description}</p>

            {features && features.length > 0 && (
              <div className="mb-4">
                <h3 className="text-xl font-medium text-gray-700 dark:text-gray-200 mb-2">
                  Points forts :
                </h3>
                <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
                  {features.map((feature, index) => (
                    <li key={index} className="text-sm">
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={closeModal}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
            >
              Fermer
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ServicesDetails;
